const headers = {
  name: "Balance Sheet",
  components: [
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
  ],
  navigate: {
    tabs: [
      {
        name: "General Ledger",
        path: "/app/common/reports",
      },
      {
        name: "Trial Balance",
        path: "/app/common/reports/trail-balance",
      },
      {
        name: "Balance Sheet",
        path: "",
      },
      {
        name: "Profit & Loss",
        path: "/app/common/reports/profit-loss",
      },
        {
        name: "AR Report",
        path: "/app/common/reports/ar-report",
      },
      {
        name: "AP Report",
        path: "/app/common/reports/ap-report",
      },
    ],
    total: [
      { value: 0, label: "Total Assets" },
      { value: 0, label: "Total Liabilities" },
      { value: 0, label: "Total Equity" },
    ],
  },
};

export default headers;
